import { ProductFilterInput } from '../../../../generated/product-service-graphql';

export const getFiltersCount = (filters: ProductFilterInput[]) => {
  return filters.reduce((acc, f) => acc + f.values.length, 0);
};
